const SITUATIONS = [
  "急に事業が決まり、案内するURLが必要",
  "イベントの開催情報と申込先をまとめたい",
  "社内の担当者だけでは、制作まで手が回らない",
];

export default function Situations() {
  return (
    <section className="bg-cream py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-16">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime-600">For You</p>
            <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-navy-950 md:text-4xl">
              公開日は迫っている。
              <br />
              でも、制作に手が回らない。
            </h2>
          </div>

          <div className="flex flex-col divide-y divide-navy-100 border-y border-navy-100">
            {SITUATIONS.map((item, i) => (
              <div key={item} className="flex items-start gap-5 py-6">
                <span className="font-heading text-2xl font-black text-lime-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="pt-1 text-base font-medium text-navy-800 md:text-lg">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}